export default __webpack_public_path__ + "static/media/Kristu-Jayanti-College.b5d264a6.png";